export const invertStrObj = (
  obj: Record<string, string>
): Record<string, string> => {
  const output = Object.entries(obj).reduce(
    (acc, entry) => {
      const [key, value] = entry;

      acc[value] = key;

      return acc;
    },
    {} as { [key: string]: string }
  );

  return output;
};
